if (!customElements.get('ong-shop-bar')) {
  customElements.define('ong-shop-bar', class extends HTMLElement {
    connectedCallback() {
      this.mainId = this.dataset.mainId;
      this.pending = false;
      this.priceMarkup = '';
      this.update = () => {
        this.pending = false;
        const main = document.getElementById(this.mainId);
        const button = main?.querySelector('product-form button[type="submit"]');
        if (!button) { this.hidden = true; return; }
        this.hidden = button.getBoundingClientRect().bottom >= 0;
        const source = main.querySelector('[id^="price-"] .price');
        const destination = this.querySelector('[data-ong-price]');
        if (source && destination) {
          const markup = source.querySelector('.price__container')?.outerHTML || '';
          const signature = source.className + markup;
          if (signature !== this.priceMarkup) {
            destination.className = 'ong-sticky-price ' + source.className;
            destination.innerHTML = markup;
            this.priceMarkup = signature;
          }
        }
      };
      this.schedule = () => {
        if (this.pending) return;
        this.pending = true;
        requestAnimationFrame(this.update);
      };
      this.goToOptions = (event) => {
        const main = document.getElementById(this.mainId);
        const picker = main?.querySelector('variant-selects');
        const destination = picker || main;
        if (!destination) return;
        event.preventDefault();
        const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        const headerHeight = document.querySelector('.section-header')?.getBoundingClientRect().height || 0;
        const top = destination.getBoundingClientRect().top + window.scrollY - headerHeight - 24;
        window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'instant' : 'smooth' });
        const control = picker?.querySelector('select, input');
        control?.focus({ preventScroll: true });
      };
      this.querySelector('[data-ong-shop]')?.addEventListener('click', this.goToOptions);
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule);
      this.observer = new MutationObserver(this.schedule);
      const main = document.getElementById(this.mainId);
      if (main) this.observer.observe(main, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled'] });
      this.schedule();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      this.querySelector('[data-ong-shop]')?.removeEventListener('click', this.goToOptions);
      this.observer?.disconnect();
    }
  });
}

